/**
 * Cookie util.
 */
export default class CookieUtility {
	/**
	 * Deletes all cookies from document.
	 */
	public static deleteAllCookies(): void {
		document.cookie.split(';').forEach((cookie) => {
			const eqPos = cookie.indexOf('=');
			const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
			this.removeCookie(name);
		});
	}

	/**
	 * Removes a cookie.
	 *
	 * @param name Name.
	 */
	public static removeCookie(name: string): void {
		document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
	}

	/**
	 * Sets a session cookie.
	 *
	 * @param name Name.
	 * @param value Value.
	 */
	public static setCookie(name: string, value: string): void {
		document.cookie = `${name}=${value}; path=/;};`;
	}

	/**
	 * Returns a cookie.
	 *
	 * @param name Name.
	 * @returns Cookie value.
	 */
	public static getCookie(name: string): string | null {
		const cookie = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
		return cookie?.pop() ?? null;
	}
}
